import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, provider } from "../../firebaseConfig";
import AuthLayout from "./AuthLayout";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";

const SignupPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSignup = async (e) => {
        e.preventDefault();
        setError("");

        try {
            if (!auth) {
                throw new Error("Firebase auth not initialized");
            }
            await createUserWithEmailAndPassword(auth, email, password);
            navigate("/onboarding");
        } catch (err) {
            console.error("Signup Error:", err);
            // Friendly error mapping optional, but good practice
            setError(err.message.replace("Firebase: ", ""));
        }
    };

    const handleGoogleLogin = async () => {
        try {
            await signInWithPopup(auth, provider);
            navigate("/onboarding");
        } catch (err) {
            console.error("Google Signup Error:", err);
            setError("Failed to sign up with Google.");
        }
    };

    return (
        <AuthLayout title="Create account">
            <form className="space-y-4 mb-6" onSubmit={handleSignup}>
                <Input
                    placeholder="Email address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                {error && <p className="text-red-500 text-sm text-center">{error}</p>}

                <div className="pt-2">
                    <Button fullWidth variant="primary" type="submit">Create account</Button>
                </div>
            </form>

            <div className="flex flex-col items-center space-y-4">
                <p className="text-sm text-gray-500 font-medium">or sign up with</p>

                <div className="flex gap-4">
                    <button
                        type="button"
                        onClick={handleGoogleLogin}
                        className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"
                    >
                        <FcGoogle size={24} />
                    </button>
                    <button type="button" className="p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
                        <FaApple size={24} />
                    </button>
                </div>

                <p className="text-xs text-gray-500 max-w-xs mt-6 leading-relaxed">
                    By creating an account you agree to Braccet's<br />
                    <Link to="#" className="font-bold text-gray-700">Terms of Services</Link> & <Link to="#" className="font-bold text-gray-700">Privacy Policy</Link>.
                </p>

                <div className="mt-8 pt-4">
                    <p className="text-sm font-medium text-gray-800">
                        Have an account? <Link to="/login" className="text-blue-600 hover:underline">Login</Link>
                    </p>
                </div>
            </div>
        </AuthLayout>
    );
};

export default SignupPage;
